import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { grey10 } from '@zocdoc/branding/colors';
import { breakpoint } from '@zocdoc/components/src/grid';
import { PaddedContainer } from '@zocdoc/components/src/Layout';
import ReviewsHeader from './ReviewsHeader';
import ReviewsBody from './ReviewsBody';
import isMobileBreakpoint from '../../../../utils/isMobileBreakpoint';
import isZocdocBrand from '../../../../utils/isZocdocBrand';
import {
    REVIEWS_TO_SHOW_ON_MOBILE,
    REVIEWS_TO_SHOW_ON_DESKTOP,
    REVIEWS_TO_SHOW_ON_DESKTOP_1Z,
} from './constants';

class ReviewsWrapper extends PureComponent {
    static propTypes = {
        rating: PropTypes.number,
        reviewCount: PropTypes.number,
        reviews: PropTypes.array,
        showAll: PropTypes.bool,
    }

    static defaultProps = {
        showAll: false,
    }

    render() {
        const {
            rating,
            reviews,
            reviewCount,
            clickFAQ,
            shouldRenderReviewCount,
            theme: { directoryId },
            trackClickIBubbleOverall,
            trackClickIBubbleWaitTime,
            trackClickIBubbleBedsideManner,
        } = this.props;
        const is1Z = isZocdocBrand(directoryId);
        let defaultNumberOfReviews;

        if (isMobileBreakpoint()) {
            defaultNumberOfReviews = REVIEWS_TO_SHOW_ON_MOBILE;
        } else if (is1Z) {
            defaultNumberOfReviews = REVIEWS_TO_SHOW_ON_DESKTOP_1Z;
        } else {
            defaultNumberOfReviews = REVIEWS_TO_SHOW_ON_DESKTOP;
        }

        if (reviews && reviews.length) {
            return (
                <ReviewWrapper>
                    <ReviewsHeader
                        clickFAQ={clickFAQ}
                        rating={rating}
                        reviewCount={reviewCount}
                        reviews={reviews}
                        shouldRenderReviewCount={shouldRenderReviewCount}
                        trackClickIBubbleBedsideManner={trackClickIBubbleBedsideManner}
                        trackClickIBubbleOverall={trackClickIBubbleOverall}
                        trackClickIBubbleWaitTime={trackClickIBubbleWaitTime}
                    />
                    <hr color={grey10} />
                    <ReviewsBody
                        {...this.props}
                        defaultNumberOfReviews={defaultNumberOfReviews}
                    />
                </ReviewWrapper>
            );
        } else {
            return (
                <div></div>
            );
        }
    }
}

export const ReviewWrapper = styled(PaddedContainer)`
    margin-top: 16px;
    padding-top: 12px;
    padding-bottom: 15px;

    ${breakpoint.small} {
        margin-top: 4px;
        padding-top: 40px;
        padding-bottom: 40px;
    }

    ${breakpoint.medium} {
        margin-top: 0;
    }
`;

export default withTheme(ReviewsWrapper);
